import React, { useState, useEffect } from "react";

const ReusableTable = ({
  data,
  columns,
  rowsPerPage,
  currentPage = 1,
  totalRecords = 0,
  loading = false,
  onPageChange,
  enableEye = false,
  enableDownload = false,
  enableSchemeStaus = false,
  onEyeClick,
  onDownloadClick,
  onRowsPerPageChange,
  onSelectedRowsChange,
  onStatusClick,
  enableCheckbox = false,
}) => {
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectAll, setSelectAll] = useState(false);

  const totalPages = Math.ceil(totalRecords / rowsPerPage);
  const startRecord = (currentPage - 1) * rowsPerPage + 1;
  const endRecord = Math.min(startRecord + rowsPerPage - 1, totalRecords);

  const filteredData = searchQuery
    ? data.filter((row) =>
      Object.values(row).some((value) =>
        String(value).toLowerCase().includes(searchQuery.toLowerCase())
      )
    )
    : data;

  useEffect(() => {
    if (selectAll) {
      setSelectedRows(filteredData.map((row) => row));
    } else {
      setSelectedRows([]);
    }
  }, [selectAll, filteredData]);


  useEffect(() => {
    if (filteredData.length > 0) {
      const allSelected = filteredData.every((row) =>
        selectedRows.some((selected) => selected.transactionId === row.transactionId)
      );
      setSelectAll(allSelected);
    } else {
      setSelectAll(false);
    }
    onSelectedRowsChange(selectedRows);
  }, [filteredData, onSelectedRowsChange, selectedRows]);


  const handleRowSelect = (row) => {
    setSelectedRows((prevSelected) => {
      let updatedSelectedRows;
      if (prevSelected.includes(row)) {
        updatedSelectedRows = prevSelected.filter((selectedRow) => selectedRow !== row);
      } else {
        updatedSelectedRows = [...prevSelected, row];
      }

      onSelectedRowsChange(updatedSelectedRows);
      return updatedSelectedRows;
    });
  };

  const handleSelectAll = (e) => {
    setSelectAll(e.target.checked);
  };

  const handlePrevPage = () => {
    if (currentPage > 1) {
      onPageChange(currentPage - 1);
    }
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      onPageChange(currentPage + 1);
    }
  };

  const handlePageChange = (page) => {
    onPageChange(page);
  };

  return (
    <div className="border-b">

      <div
        className="overflow-x-auto h-[450px] hidden sm:block"
        style={{
          maxHeight: "450px",
          width: "100%",
          position: "relative",
        }}
      >
        <table className="min-w-full table-auto border-collapse border border-gray-200">
          <thead className="bg-[#1e365e] sticky top-0">
            <tr className="text-center text-white">
              {enableCheckbox && (
                <th className="px-4 py-4 border border-gray-200 text-l">
                  <input
                    type="checkbox"
                    checked={selectAll}
                    onChange={handleSelectAll}
                    className="form-checkbox"
                  />
                </th>
              )}
              <th className="px-1 py-1 border border-gray-200" style={{ fontWeight: 'normal' }}>S.No</th>
              {columns.map((col) => (
                <th
                  key={col.key}
                  style={{ fontWeight: 'normal' }}
                  className={`px-1.5 py-3 text-md border border-gray-200 ${col.isTextAlignRight ? "text-right" : "text-center"
                    }`}
                >
                  {col.label}
                </th>
              ))}
              {(enableEye || enableDownload || enableSchemeStaus) && (
                <th style={{ fontWeight: 'normal' }} className="px-1 py-1 border text-l border-gray-200">
                  Action
                </th>
              )}
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td
                  colSpan={
                    columns.length +
                    (enableEye ? 1 : 0) +
                    (enableDownload ? 1 : 0) +
                    (enableCheckbox ? 1 : 0) +
                    (enableSchemeStaus ? 1 : 0) +
                    1
                  }
                  className="text-center py-6"
                >
                  <div className="flex justify-center items-center">
                    <div className="animate-spin rounded-full h-6 w-6 border-t-2 border-b-2 border-blue-900"></div>
                  </div>
                </td>
              </tr>
            ) : filteredData.length > 0 ? (
              filteredData.map((row, idx) => (
                <tr
                  key={idx}
                  className="hover:bg-gray-100 even:bg-white odd:bg-slate-300"
                >
                  {enableCheckbox && (
                    <td className="px-4 py-2.5 border border-gray-200 text-center">
                      <input
                        type="checkbox"
                        checked={selectedRows.includes(row)}
                        onChange={() => handleRowSelect(row)}
                        className="form-checkbox"
                      />
                    </td>
                  )}
                  <td className="px-4 py-2.5 border border-gray-200 text-center">
                    {startRecord + idx}
                  </td>
                  {columns.map((col) => (
                    <td
                      key={col.key}
                      style={{ whiteSpace: "nowrap" }}
                      className={`px-1.5 py-1 border border-gray-200 ${col.isTextAlignRight ? "text-right" : "text-center"}`}
                    >
                      {col.key === "status" ? (
                        <span
                          className="px-2 py-1 rounded-lg text-sm"
                          style={{
                            backgroundColor:
                              row[col.key] === "CreditNote Updated"
                                ? "#A5D6A7"
                                : row[col.key] === "Approved"
                                  ? "#90CAF9"
                                  : row[col.key] === "Pending Approval"
                                    ? "#FFF176"
                                    : "#E0E0E0",
                            color: "#000",
                          }}
                        >
                          {row[col.key]}
                        </span>
                      ) : col.key === "isActive" ? (
                        <span
                          className={`px-2 py-1 rounded-lg text-sm font-medium ${row[col.key] ? "bg-green-900 text-green-100" : "bg-red-900 text-red-100"
                            }`}
                        >
                          {row[col.key] ? "Active" : "Inactive"}
                        </span>
                      ) : col.isCurrency ? (
                        `₹ ${row[col.key]}`
                      ) : col.key === "category" ? (
                        Array.isArray(row[col.key]) ? row[col.key][0] : row[col.key]
                      ) : (
                        row[col.key]
                      )}
                    </td>
                  ))}


                  {enableSchemeStaus && (
                    <td className="px-4 py-2.5 border border-gray-200 text-center">
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          onStatusClick && onStatusClick(row);
                        }}
                        style={{ color: "#1976D2", textDecoration: "underline" }}
                      >
                        Edit
                      </button>
                    </td>
                  )}

                  {enableEye && (
                    <td className="px-4 py-2.5 border border-gray-200 text-center">
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          onEyeClick && onEyeClick(row);
                        }}
                        style={{ color: "#1976D2", textDecoration: "underline" }}
                      >
                        View
                      </button>
                    </td>
                  )}

                  {enableDownload && (
                    <td className="px-4 py-2.5 border border-gray-200 text-center">
                      <button
                        onClick={(e) => {
                          e.stopPropagation();
                          onDownloadClick && onDownloadClick(row);
                        }}
                        style={{ color: "#1976D2", textDecoration: "underline" }}
                      >
                        Download
                      </button>
                    </td>
                  )}
                </tr>
              ))
            ) : (
              <tr>
                <td
                  colSpan={
                    columns.length +
                    (enableEye ? 1 : 0) +
                    (enableDownload ? 1 : 0) +
                    (enableCheckbox ? 1 : 0) +
                    (enableSchemeStaus ? 1 : 0) +
                    1
                  }
                  className="text-center py-2 text-gray-500"
                >
                  No data found
                </td>
              </tr>
            )}
          </tbody>

        </table>
      </div>

      <div className="flex justify-between items-center px-1 py-1 border-t mt-2">
        <div>
          <p className="text-md text-gray-700 mt-2">
            Showing{" "}
            <span className="font-medium">{startRecord}</span> to{" "}
            <span className="font-medium">{endRecord}</span> of{" "}
            <span className="font-medium">{totalRecords}</span> results
          </p>
        </div>

        <div>
          <label className="text-gray-700 font-medium mr-2">Rows per page:</label>
          <select
            value={rowsPerPage}
            onChange={onRowsPerPageChange}
            className="px-2 py-1.5 border border-gray-300 rounded-lg shadow-sm text-gray-700 focus:outline-none focus:ring-2 focus:ring-slate-500 focus:border-slate-500 transition duration-200 ease-in-out mr-2"
            style={{
              backgroundColor: "#F0F2F6",
              width: "auto",
            }}
            disabled={selectAll}
          >
            <option value={10}>10</option>
            <option value={20}>20</option>
            <option value={30}>30</option>
            <option value={40}>40</option>
            <option value={50}>50</option>
          </select>
          <nav className="isolate inline-flex -space-x-px rounded-md shadow-sm bg-slate-100" aria-label="Pagination">
            <button
              onClick={handlePrevPage}
              disabled={currentPage === 1}
              className={`relative inline-flex items-center px-2 py-1 text-lg font-medium ${currentPage === 1 ? "text-gray-400 cursor-not-allowed" : "text-slate-600 hover:bg-gray-50"
                }`}
            >
              &lt;
            </button>

            <button
              onClick={() => handlePageChange(1)}
              className={`relative inline-flex items-center px-3 py-1 text-lg font-medium ${currentPage === 1 ? "bg-[#1e365e] text-white" : "text-slate-600 hover:bg-gray-50"
                }`}
            >
              1
            </button>

            {currentPage > 5 && <span className="px-3 py-1">...</span>}

            {(() => {
              let pages = [];
              if (currentPage <= 5) {
                pages = Array.from({ length: Math.min(5, totalPages - 1) }, (_, i) => i + 2);
              } else if (currentPage >= totalPages - 4) {
                pages = Array.from({ length: 5 }, (_, i) => totalPages - 5 + i);
              } else {
                pages = Array.from({ length: 5 }, (_, i) => currentPage - 2 + i);
              }

              return pages.map((page) => (
                <button
                  key={page}
                  onClick={() => handlePageChange(page)}
                  className={`relative inline-flex items-center px-3 py-1 text-lg font-medium ${currentPage === page ? "bg-[#1e365e] text-white" : "text-slate-600 hover:bg-gray-50"
                    }`}
                >
                  {page}
                </button>
              ));
            })()}

            {currentPage < totalPages - 6 && totalPages > 6 && <span className="px-3 py-1">...</span>}

            {totalPages > 6 && (
              <button
                onClick={() => handlePageChange(totalPages)}
                className={`relative inline-flex items-center px-3 py-1 text-lg font-medium ${currentPage === totalPages ? "bg-[#1e365e] text-white" : "text-slate-600 hover:bg-gray-50"
                  }`}
              >
                {totalPages}
              </button>
            )}

            <button
              onClick={handleNextPage}
              disabled={currentPage === totalPages}
              className={`relative inline-flex items-center px-2 py-1 text-lg font-medium ${currentPage === totalPages ? "text-gray-400 cursor-not-allowed" : "text-slate-600 hover:bg-gray-50"
                }`}
            >
              &gt;
            </button>
          </nav>

        </div>
      </div>
    </div>
  );
};


export default ReusableTable;
